// extracted by mini-css-extract-plugin
export var root = "Gtr7";
export var rootContainer = "+4WL";
export var rootContent = "_2iLH";
export var rootDescription = "yogX";
export var rootHeading = "cKm0";
export var rootHeadingLink = "AFpT";
export var rootLabel = "YvVC";
export var rootMain = "UVsA";
export var rootScore = "ajuE";
export var rootScoreStars = "IiDA";
export var rootScoreText = "xrvE";
export var rootScoreValue = "Ua5m";